export const MESSAGE_JUMP_RAIL_WIDTH = 40;

export function clippingViewRect(el: HTMLElement | null): { top: number; bottom: number } {
    let top = 0;
    let bottom = typeof window === 'undefined' ? 0 : window.innerHeight;
    let node = el?.parentElement ?? null;
    while (node && node !== document.body) {
        const overflowY = window.getComputedStyle(node).overflowY;
        if (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'hidden') {
            const rect = node.getBoundingClientRect();
            top = Math.max(top, rect.top);
            bottom = Math.min(bottom, rect.bottom);
        }
        node = node.parentElement;
    }
    return { top, bottom };
}

export function collectScrollParents(el: HTMLElement | null): HTMLElement[] {
    const nodes: HTMLElement[] = [];
    let node = el?.parentElement ?? null;
    while (node && node !== document.body) {
        const overflowY = window.getComputedStyle(node).overflowY;
        if (overflowY === 'auto' || overflowY === 'scroll')
            nodes.push(node);
        node = node.parentElement;
    }
    return nodes;
}

export type PinnedRailBox = {
    top: number;
    left: number;
    height: number;
};

const AVATAR_SIZE = 28;
const AVATAR_GAP = 20;
const VIEW_PADDING = 16;

export function railNaturalHeight(messageCount: number): number {
    if (messageCount <= 0)
        return 0;
    return messageCount * AVATAR_SIZE + Math.max(0, messageCount - 1) * AVATAR_GAP;
}

export function pinnedRailBox(
    wrapperRect: { top: number; bottom: number; right: number },
    viewRect: { top: number; bottom: number },
    messageCount: number,
    railWidth = MESSAGE_JUMP_RAIL_WIDTH,
): PinnedRailBox {
    const visibleTop = Math.max(wrapperRect.top, viewRect.top + VIEW_PADDING);
    const visibleBottom = Math.min(wrapperRect.bottom, viewRect.bottom - VIEW_PADDING);
    const visibleHeight = Math.max(0, visibleBottom - visibleTop);
    const height = Math.min(Math.max(railNaturalHeight(messageCount), AVATAR_SIZE), visibleHeight);
    return {
        top: visibleTop,
        left: wrapperRect.right - railWidth,
        height,
    };
}
